<script>
  import AppMenu from './MenuTransparencia.vue';
  import Navbar from './Navbar.vue';
  import AppFooter from './Footer.vue';
  import VoltarAoTopo from './VoltarAoTopo.vue';
  import PageHeader from './PageHeaderTransparencia.vue';
  import "../js/inspinia";

  export default {
    name: 'layout',
    components: { AppMenu, Navbar, PageHeader, AppFooter, VoltarAoTopo }
  }
</script>

<template>
  <div id="wrapper">
    <app-menu></app-menu>

    <div id="page-wrapper" class="gray-bg">
      <navbar></navbar>

      <page-header></page-header>

      <router-view></router-view>
      
      <div class="padding-20"></div>
      
      <app-footer></app-footer>
      
      <voltar-ao-topo></voltar-ao-topo>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutTransparencia.vue